<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="telZones"
      :items="telZones"
      :fields="telZonesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal :editItem="selectedTelZones"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      telZonesFields: [
        {key: 'zone_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true, formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'supplier_id', label: this.$i18n.t('Supplier id'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTelZones: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedTelZones = {
        zone_id: 0,
        name: '',
        type: 0,
        directions: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditTelephoneZones', '#btnShow')
    },
    async editItem (item) {
      await this.$store.dispatch('Tariffing/GET_TEL_ZONE', item.zone_id).then(response => {
        this.selectedTelZones = this.$store.getters['Tariffing/TEL_ZONE']
      })
      this.$root.$emit('bv::show::modal', 'modalEditTelephoneZones', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Telephone zones"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_TEL_ZONES', item.zone_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TEL_ZONES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    telZones () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TEL_ZONES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneZones/main.vue